import { mapGetters, mapState } from 'vuex'

export var currencyMixin = {
  computed: {
    ...mapGetters({
      getCurrencies: 'systemModule/getSystemCurrencies',
    }),
    //Currency Store
    ...mapState('currencyModule', ['currency']),
  },
  methods: {
    getCurrencyLocation(currency) {
      if (currency) {
        let cifrao = currency.cifrao
        if (cifrao.toLowerCase() === 'r$') return 'BRL'
        else if (cifrao.toLowerCase() === 'u$') return 'USD'
        else if (cifrao.toLowerCase() === 'g$') return 'PYG'
        else if (cifrao.toLowerCase() === 'e$') return 'EUR'
        else if (cifrao.toLowerCase() === 'p$') return 'ARS'
        else return this.getCurrencyLocation(this.getCurrencies[0])
      } else {
        return 'BRL'
      }
    },
    getCurrencyFractionDigits(indiceMoeda = 0) {
      const listCurrencies = this.getCurrencies
      if (listCurrencies) {
        let moeda = listCurrencies[indiceMoeda]
        const pos = moeda.mascara.indexOf('.')
        if (pos !== -1)
          return moeda.mascara.substring(pos + 1, moeda.mascara.length).length
        else return 0
      }
    },
    formatCurrency(indiceMoeda = 0, value, style = 'currency') {
      const listCurrencies = this.getCurrencies
      if (value && value !== '' && listCurrencies) {
        const fmt = value.toString().replace(',', '.')

        let moeda = listCurrencies[indiceMoeda]
        return new Intl.NumberFormat('pt-BR', {
          style: style,
          currency: this.getCurrencyLocation(moeda),
          minimumFractionDigits: moeda
            ? this.getCurrencyFractionDigits(indiceMoeda)
            : 2,
        }).format(fmt)
      } else {
        return '0'
      }
    },
    formatDecimal(value, maxQntDecimal = 4, minQntDecimal = 2) {
      let retorno = new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        maximumFractionDigits: maxQntDecimal,
        minimumFractionDigits: minQntDecimal,
      }).format(value)
      return retorno.replace(/[^0-9,-]/g, '').replace(/,/, '.')
    },
    /*
     * Retorna o valor da tabela de câmbios de acordo a moeda informada
     */
    getCambioAtual(indexMoeda) {
      const currency = this.currency[0]
      let cambio = 0
      switch (indexMoeda) {
        case 0:
          cambio = 1
          break
        case 1:
          cambio = currency.CAMBIO1
          break
        case 2:
          cambio = currency.CAMBIO2
          break
        case 3:
          cambio = currency.CAMBIO3
          break
        case 4:
          cambio = currency.CAMBIO4
          break
        case 5:
          cambio = currency.CAMBIO5
          break
      }
      return cambio
    },
    /*
     * Realiza o cambio de um valor informado
     */
    calculaCambio(currency, valorMoeda0) {
      let valorFinal = 0
      let cambio = this.getCambioAtual(currency.index)
      if (currency.sinal == '/') valorFinal = parseFloat(valorMoeda0) / cambio
      else valorFinal = parseFloat(valorMoeda0) * cambio
      return valorFinal
    },
  },
}
